import { HotmartRum } from '@hot-observability-js/browser'
import Package from '@/package.json'
import { SSO_USER } from './user'

HotmartRum.init({
  release: `${process.env.SENTRY_PROJECT}@${Package.version}`,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.NODE_ENV === 'production' ? 'production' : 'staging',
})


const setUser = (event?: CustomEvent<string>) => HotmartRum.setUser({
  id: event?.detail || SSO_USER.get('uuid')
})

setUser()
SSO_USER.uuidManager.onChange(setUser)

export { HotmartRum }
